module.exports = __webpack_public_path__ + "img/u154.b346a7ed.png";